module.exports = __webpack_public_path__ + "static/media/widget.eb9afe1a.svg";